import template from './tooltipMobile.html';
import controller from './tooltipMobile.controller';
import './tooltipMobile.scss';

let tooltipMobileComponent = {
  restrict: 'E',
  transclude: true,
  bindings: {
    name: '@',
    nestedModals: '<',
    idNestedModal: '@'
  },
  template,
  controller
};

export default tooltipMobileComponent;



// WEBPACK FOOTER //
// ./client/app/components/tooltipMobile/tooltipMobile.component.js